module.exports = __webpack_public_path__ + "1fcdc5a4.svg";